import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { createStompClient, disconnectStomp } from "../services/socketService";
import { TruePlanVars } from "../TruePlan";

const SocketContext = createContext({ stomp: null, connected: false });

export const SocketProvider = ({ children }) => {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const [stomp, setStomp] = useState(null);
  const [connected, setConnected] = useState(false);

  const socketUrl = TruePlanVars.varSocketURL || "http://localhost:8080/ws";

  useEffect(() => {
    let client;

    async function initSocket() {
      if (!isAuthenticated) return;

      const token = await getAccessTokenSilently();

      client = createStompClient(socketUrl, token, {
        onConnect: () => {
          setConnected(true);
        },
        onDisconnect: () => {
          setConnected(false);
        },
      });
      setStomp(client);
    }

    if (!isLoading && isAuthenticated) {
      initSocket();
    }

    return () => {
      disconnectStomp();
      setConnected(false);
      setStomp(null);
    };
  }, [isAuthenticated, isLoading, getAccessTokenSilently, socketUrl]);

  return (
    <SocketContext.Provider value={{ stomp, connected }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocketContext = () => useContext(SocketContext);
